import React from "react";
import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Typography,
  Button,
} from "@mui/material";
import ArrowForwardOutlinedIcon from "@mui/icons-material/ArrowForwardOutlined";
import { useNavigate } from "react-router-dom";
import {
  cardHover,
  cardOutline,
  fonts,
  headingFonts,
  mainButtonStyles,
} from "../../Styles/Styles";

const ServiceProviderCard = ({ provider }) => {
  const navigate = useNavigate();

  const handleViewProfileClick = (providerId) => {
    navigate(`/expert/${providerId}`);
  };
  return (
    <Card
      sx={{
        display: "flex",
        alignItems: "center",
        pt: 5,
        pb: 5,
        pl: 3,
        pr: 3,
        mb: 3,
        ...cardOutline,
        ...cardHover,
      }}
    >
      {/* Image */}
      <CardMedia
        component="img"
        image={provider.image}
        alt={provider.name}
        sx={{
          width: 120,
          height: 120,
          borderRadius: 100,
          mr: 3,
        }}
      />

      {/* Text Content */}
      <Box sx={{ flex: 1 }}>
        <CardContent sx={{ p: 0 }}>
          <Typography variant="h6" gutterBottom sx={{ ...headingFonts }}>
            {provider.name}
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            gutterBottom
            sx={{
              ...fonts,
              display: "-webkit-box",
              overflow: "hidden",
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: 2, // Limit to 2 lines
            }}
          >
            {provider.description}
          </Typography>
        </CardContent>
        <Button
          onClick={() => handleViewProfileClick(provider._id)}
          className="main-button-style"
          sx={{
            mt: 2,
            ...mainButtonStyles,
            padding: "5px 25px",
          }}
        >
          <span>View Profile</span>
          <ArrowForwardOutlinedIcon fontSize="small" />
        </Button>
      </Box>
    </Card>
  );
};

export default ServiceProviderCard;
